// src/components/StoryBookPopup.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import CalendarView from './CalendarView';

const StoryBookPopup = ({
  selectedDates,
  setSelectedDates,
  onClose,
  onGenerate,
  title = "Create Story Book", // Default title
  generateButtonText = "Generate Story Book" // Default button text
}) => {
  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      {/* Use the dynamic title prop */}
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <CalendarView
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          multiSelect={true}
          selectedDate={null}
          setSelectedDate={() => {}}
          setPhotoBrowsingDate={() => {}}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        {/* Use the dynamic generate button text prop */}
        <Button onClick={onGenerate} color="primary" variant="contained">
          {generateButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoryBookPopup;